"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
exports.__esModule = true;
exports.default = void 0;
var _styledComponents = require("styled-components");
var _mediaQuery = _interopRequireDefault(require("../../utils/mediaQuery"));
var _consts = require("../../utils/mediaQuery/consts");
const getViewportHideStyles = (on, resolveDisplayProp) => Object.values(_consts.DEVICES).map(viewport => viewport in _mediaQuery.default ? (0, _styledComponents.css)(["", ";"], _mediaQuery.default[viewport]((0, _styledComponents.css)(["display:", ";"], on.indexOf(viewport) !== -1 ? "none" : resolveDisplayProp && resolveDisplayProp()))) :
// "smallMobile" is not media query so we need to check it explicitly
viewport === "smallMobile" && on.indexOf(viewport) !== -1 && (0, _styledComponents.css)(["display:none;"]));
var _default = getViewportHideStyles;
exports.default = _default;